import type { HomeInsight } from "@/content/home";
import { Keycap } from "@/components/keycap/Keycap";
import { CtaLink } from "@/components/Button";
import "./InsightCard.css";

/**
 * One of the homepage's four dominant ideas: a number, a one-word heading,
 * one sentence, and one key. No diagram, no bullet list — the four insights
 * are meant to be scanned, not read as a spec. See
 * docs/DESIGN_ASSESSMENT_2026-07.md §7 and the keycap art-direction pass.
 */
export function InsightCard({ insight }: { insight: HomeInsight }) {
  return (
    <article className="insight-card">
      <Keycap id={insight.keycap} size="xl" />
      <p className="insight-card-number">{insight.number}</p>
      <h3 className="insight-card-title">{insight.title}</h3>
      <p className="insight-card-body">{insight.body}</p>
      <CtaLink to={insight.link.to} variant="secondary">
        {insight.link.label}
      </CtaLink>
    </article>
  );
}
